module.exports = __webpack_public_path__ + "static/media/ElonMusk.d0c6f84d.png";